//router
import LayoutsRoute from "./router/layouts-route";

//scss files
import "./assets/css/bootstrap.min.css";
import "./assets/css/typography.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";
import ScrollToTop from "./components/ScrollToTop";
// import  './assets/css/custom.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            theme="dark"
            pauseOnFocusLoss={false}
            pauseOnHover={false}
            progressClassName="fancy-progress-bar"
          />
          {/* Same as */}
          <LayoutsRoute />
        </ScrollToTop>
      </BrowserRouter>
      {/* <LayoutsRoute /> */}
    </div>
  );
}

export default App;
